<template>
  <v-card>
    <!-- <v-expansion-panels  v-if="data.length">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        行銷圖卡排程圖
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-card-subtitle class="d-flex justify-space-around">
                            
                            <v-menu
                                v-model="displayDatePickerStart"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="chartStartAt"
                                        label="開始時間"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        color="#5087e6"
                                    ></v-text-field>
                                </template>

                                <v-date-picker
                                    v-model="chartStartAt"
                                    @input="displayDatePickerStart = false"
                                    locale="zh-cn"
                                    header-color="#5087e6"
                                    color="#5087e6"
                                ></v-date-picker>
                            </v-menu>

                            <v-menu
                                v-model="displayDatePickerEnd"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="chartEndAt"
                                        label="結束時間"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        color="#5087e6"
                                    ></v-text-field>
                                </template>

                                <v-date-picker
                                    v-model="chartEndAt"
                                    @input="displayDatePickerEnd = false"
                                    locale="zh-cn"
                                    header-color="#5087e6"
                                    color="#5087e6"
                                ></v-date-picker>
                            </v-menu>

                        </v-card-subtitle>

                        <GanttChart 
                            v-if="data.length"
                            :chartData="data"
                            :chartLabels="labels"
                            :chartTitle="`行銷圖卡任務管理`"
                            :startAt="chartStartAt"
                            :endAt="chartEndAt"
                        />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels> -->

    <v-expansion-panels class="mt-2">
      <v-expansion-panel>
        <v-expansion-panel-header ref="batchEditButton"> 批量修改 </v-expansion-panel-header>
        <v-expansion-panel-content>
          <BatchEdit @update="updateItemsAfterBatchEdit" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card-title class="text_primary pb-0">
      <!-- <v-icon left class="text_primary">
            mdi-format-list-bulleted-type
          </v-icon> -->

      {{ `行銷圖卡` }}

      <v-spacer></v-spacer>

      <div class="" style="text-align: right">
        <v-btn
          :disabled="quota_setting.quantity >= quota_setting.limit"
          class="white--text"
          color="#5087e6"
          @click="addNewSetting()"
        >
          <v-icon v-if="quota_setting.quantity >= quota_setting.limit" small class="mr-2">mdi-lock</v-icon>
          新增
        </v-btn>
      </div>
    </v-card-title>
    <div
      v-if="quota_setting.quantity >= quota_setting.limit"
      class="d-flex justify-end mt-1 pr-3"
      style="color: red; font-size: 14px"
    >
      已達使用上限，請加購或刪除現有圖卡。
    </div>
    <UsedQuotaInfo
      v-if="quota_setting.is_show"
      :service="'可建立圖卡數'"
      :usage="quota_setting.quantity"
      :limit="quota_setting.limit"
      :is_show_percentbar="quota_setting.is_show_percentbar"
    />

    <div>
      <div class="pl-4 pr-4 pb-3 pt-2">
        <v-row>
          <v-col cols="12" lg="8" md="12" xs="12">
            <v-card-text class="d-flex align-center justify-end pl-0 ml-0 pt-0 pr-0 pb-0">
              <v-text-field
                v-model="search"
                dense
                outlined
                class="pt-0 pl-0 ml-0"
                label="輸入關鍵字搜索(圖卡名稱/圖卡代碼)"
                single-line
                hide-details
                color="primary"
                @keypress.enter="searchKeyword(search)"
              ></v-text-field>
              <v-btn class="ml-3 btn_action btn_action_bg_linear" @click="searchKeyword(search)">
                <v-icon> mdi-magnify </v-icon>
              </v-btn>
            </v-card-text>
          </v-col>
          <v-col cols="12" lg="4" md="12" xs="12">
            <v-card-text class="d-flex align-center justify-end pa-0">
              <p class="mb-0 pb-0 mr-3">顯示</p>
              <v-select
                v-model="selected_per_page"
                style="max-width: 7em"
                outlined
                return-object
                :items="per_page_items"
                item-value="value"
                item-text="name"
                hide-details
                dense
                @change="chagePerPage(selected_per_page)"
              >
              </v-select>
            </v-card-text>
          </v-col>
        </v-row>
      </div>

      <!-- <v-card-title id="marketing_card" >
                行銷圖卡設定檔列表
                <v-spacer></v-spacer>
                <v-btn
                    class="mr-2 white--text"
                    :color="this.$vuetify.theme.themes['dark']['primary']"
                    @click="addNewSetting()"
                >
                    <v-icon left>
                        mdi-note-plus-outline
                    </v-icon>
                    新增圖卡設定檔
                </v-btn>
            </v-card-title> -->

      <v-tabs v-model="tab_setting.tab" show-arrows center-active color="primary">
        <v-tab v-for="item in tab_setting.modes" :key="item.id" @click="changeTab(item)">
          {{ item.title }}
        </v-tab>
      </v-tabs>
      <v-data-table
        :loading="is_loading"
        :loading-text="loading_text"
        :no-data-text="'無行銷圖卡設定。'"
        :no-results-text="'找不到相符行銷圖卡設定。'"
        :headers="headers"
        :items="items"
        :items-per-page="selected_per_page.value"
        hide-default-footer
      >
        <template #[`item.status`]="{ item }">
          <template v-if="item.repeat_day && item.status === 'running'">
            <v-chip text-color="white" label :color="'primary'"> 循環 </v-chip>
          </template>
          <template v-else>
            <v-chip
              v-if="tab_setting.tab_name_mapper[item.status]"
              text-color="white"
              label
              :color="tab_setting.tab_name_mapper[item.status].color"
            >
              {{ tab_setting.tab_name_mapper[item.status].name }}
            </v-chip>
          </template>
        </template>

        <template #[`item.setting_name`]="{ item }">
          <div class="table-row-pointer table-truncate" @click="viewInfo(item)">
            {{ item.setting_name }}
          </div>
        </template>

        <template #[`item.preview_url`]="{ item }">
          <div class="d-flex align-center">
            <div class="table-truncate">
              {{ item.preview_url }}
            </div>
            <v-icon small @click="rowPreview(item)"> mdi-open-in-new </v-icon>
          </div>
        </template>

        <template #[`item.coupon_id`]="{ item }">
          <div class="truncate mx-width-150">
            {{ item.coupon_id }}
          </div>
        </template>

        <template #[`item.start_at`]="{ item }">
          <div v-html="foramtDisplayDate(item.start_at)"></div>
        </template>

        <template #[`item.end_at`]="{ item }">
          <div v-html="foramtDisplayDate(item.end_at)"></div>
        </template>

        <template #[`item.tags`]="{ item }">
          <div v-html="formatTag(item.tags)"></div>
        </template>

        <template #[`item.actions`]="{ item, attrs, on }">
          <v-menu offset-y bottom right v-bind="attrs" v-on="on">
            <template #activator="{ on }">
              <v-btn icon v-on="{ ...on }">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="previewCard(item)">
                <v-list-item-title>
                  <v-icon left> mdi-eye-arrow-right </v-icon>
                  預覽
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="viewInfo(item)">
                <v-list-item-title>
                  <v-icon left> mdi-pencil </v-icon>
                  修改
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="deleteSettingCard(item)">
                <v-list-item-title>
                  <v-icon left> mdi-trash-can-outline </v-icon>
                  刪除
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="copyCard(item)">
                <v-list-item-title>
                  <v-icon left> mdi-content-duplicate </v-icon>
                  複製
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>

      <!-- <CustomDataTable

                :feature="feature"
                @viewInfo="viewInfo"
                @delete="deleteSettingCard"
                @preview="previewCard"
                @copy="copyCard"
                :search="search"
                :items-per-page="per_page"
            /> -->

      <div class="text-center mt-5">
        <Pagination v-if="page_setting.is_show" :setting="page_setting" @changePage="changePageCallback" />
      </div>
    </div>

    <v-dialog v-if="preview_dialog.is_show" v-model="preview_dialog.is_show" width="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ preview_dialog.title }}
        </v-card-title>
        <v-radio-group v-model="preview_dialog.row" dense row class="pl-5">
          <v-radio dense label="當下時間" value="by_now"></v-radio>
          <!-- <v-radio
                            dense
                            label="圖卡類型(預覽用)"
                            value="by_activity"
                        ></v-radio> -->
          <v-radio dense label="指定時間(預覽用)" value="by_time"></v-radio>
        </v-radio-group>

        <v-card-text v-if="preview_dialog.row === 'by_activity'">
          <v-select
            v-model="preview_dialog.selected_mode"
            outlined
            :items="preview_dialog.copy_mode_items"
            hide-details
            dense
            return-object
          >
          </v-select>
        </v-card-text>

        <v-card-text v-if="preview_dialog.row === 'by_time'">
          <date-picker
            v-model="preview_dialog.selected_time"
            :shortcuts="$utils.date_picker_shorcuts"
            style="width: 100%"
            type="datetime"
          >
          </date-picker>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closePreview"> 關閉 </v-btn>
          <v-btn color="primary" text @click="confirmPreview"> 預覽 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import UsedQuotaInfo from '@/components/Utils/UsedQuotaInfo.vue'
// DatePicker!
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw'

// import MarketingCardTabs from './MarketingCardTabs.vue';
import BatchEdit from './BatchEditByAd/BatchEdit.vue'
// import LoadingOverlay from "@/components/Utils/LoadingOverlay.vue";
import Pagination from '@/components/Utils/Pagination.vue'
// import UsedQuotaInfo from "@/components/Utils/UsedQuotaInfo.vue";

// import CountDownTimerList from "./CountDownTimerList.vue";
// import GanttChart from "@/components/Utils/GanttChart.vue"
// import date-fns locale:
import 'chartjs-adapter-date-fns'
import { enUS } from 'date-fns/locale'
// import { Chart } from 'chart.js';

import {
  apiGetCard,
  apiCardFindBy,
  // apiUpdateCard,
  // apiCreateCard,
  apiDeleteCard,
  apiGetPreviewToken,
  apiCopyCard,
} from '@/api/sales-card.js'

import { apiGetSubscriptionInfoWithData } from '@/api/organize.js'

export default {
  // inject:['tab'],
  // provide: {
  //     mainChoosedItems: this.items
  // },
  name: 'MarketingCardSettingSettingCardList',
  components: {
    DatePicker,
    // MarketingCardTabs,
    BatchEdit,
    // LoadingOverlay,
    Pagination,
    // GanttChart,
    UsedQuotaInfo,
    // UsedQuotaInfo
    // Chart
    // CountDownTimerList
  },
  data() {
    return {
      preview_dialog: {
        copy_setting: null,
        setting: null,
        row: 'by_now',
        title: '預覽圖卡',
        is_show: false,
        selected_mode: {
          text: '活動進行',
          value: 'activity_card_setting',
        },
        selected_time: '',
        copy_mode_items: [],
        mode_items: [
          {
            text: '活動預熱',
            value: 'warm_up_setting',
          },
          {
            text: '活動進行',
            value: 'activity_card_setting',
          },
          {
            text: '活動結束',
            value: 'end_up_setting',
          },
        ],
      },

      displayDatePickerStart: false,
      displayDatePickerEnd: false,
      chartStartAt: '',
      chartEndAt: '',
      data: [
        // 裡面格式會長這樣，才能做成甘特圖
        // { x: ["2023-07-02","2023-07-06"], y: "task1" },
      ],
      labels: [],
      chartDatas: {
        labels: [],
        datasets: [
          {
            label: '每日用量',
            data: [
              // { x: ["2023-07-05","2023-07-10"], y: "task1" },
              // { x: ["2023-07-08","2023-07-13"], y: "task2" },
              // { x: ["2023-07-15","2023-07-20"], y: "task3" },
              // { x: ["2023-07-21","2023-07-28"], y: "task4" }
            ],
            fill: true,
            borderColor: '#E1BEE7',
            tension: 0.5,
            backgroundColor: ['#CE93D8', '#CE93D8'],
            spanGaps: true,
          },
          {
            label: '配額上限',
            data: [],
            fill: true,
            borderColor: 'orange',
            tension: 0.2,
            backgroundColor: 'orange',
            spanGaps: true,
          },
        ],
        barPercentage: 0.6,
        borderWidth: 1,
        borderSkipped: false,
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        scales: {
          x: {
            type: 'time',
            time: {
              parser: 'YYYY-MM-DD', // 指定輸入日期的格式
              unit: 'day', // 指定時間軸的間距
              displayFormats: {
                day: 'YYYY-MM-DD', // 指定顯示日期的格式
              },
            },
          },
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'day',
              },
              //   distribution: 'linear'
            },
          ],
          y: {
            beginAtZero: true,
          },
        },
        parsing: {
          // 資料 x 軸的 key，預設為 x
          // xAxisKey: "date",
          // 資料 y 軸的 key，預設為 y
          // yAxisKey: "count",
        },
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: '行銷圖卡任務圖',
          },
        },
        adapters: {
          date: {
            locale: enUS,
          },
        },
      },
      per_page: 10,
      page_setting: {
        is_show: false,
        selected_page: 1,
        total_page: 10,
        total_visible: 5,
      },
      feature: 'marketing_card',
      search: '',
      headers: [
        { text: '狀態', value: 'status', sortable: false },
        { text: '圖卡名稱', value: 'setting_name', sortable: false },
        { text: '預覽連結', value: 'preview_url', sortable: false },
        { text: '圖卡代碼', value: 'coupon_id', sortable: false },
        { text: '開始時間', value: 'start_at', sortable: true },
        { text: '結束時間', value: 'end_at', sortable: true },
        { text: '區域', value: 'tags', sortable: false },
        // { text: '編輯者', value: 'editor', sortable: false},
        { text: '', value: 'actions', sortable: false },
      ],
      items: [],
      // prop_tab: this.tab,
      search_tags: '',
      allCardSettingResponse: null,
      selected_per_page: {
        name: '48筆',
        value: 48,
      },
      per_page_items: [
        {
          name: '10筆',
          value: 10,
        },
        {
          name: '24筆',
          value: 24,
        },
        {
          name: '48筆',
          value: 48,
        },
        {
          name: '100筆',
          value: 100,
        },
      ],

      is_loading: false,
      loading_text: '載入中',
      quota_setting: {
        display_name: '圖卡總數',
        is_show: false,
        quantity: 0,
        limit: 0,
        is_show_percentbar: true,
      },
      tab_setting: {
        tab: null,
        default_tab: {
          id: 'all',
          title: '全部',
        },
        tab_name_mapper: {
          draft: {
            name: '草稿',
            color: this.$vuetify.theme.themes.light.draft,
          },
          running: {
            name: '發布',
            color: this.$vuetify.theme.themes.light.release,
          },
          disable: {
            name: '結束',
            color: this.$vuetify.theme.themes.light.end,
          },
        },
        modes: [
          {
            id: 'all',
            title: '全部',
          },
          {
            id: 'draft',
            title: '草稿',
          },
          {
            id: 'running',
            title: '發布',
          },
          {
            id: 'disable',
            title: '結束',
          },
        ],
      },
    }
  },
  computed: {},
  watch: {},
  async created() {
    try {
      this.is_loading = true
      await this.initData()
      await this.$store.commit('marketing_card_setting', this.items)

      // this.items是true的話，執行this.initChart()，等價於 this.items ? this.initChart() : this.items
      this.items && this.initChart()

      await this.getQuota()
      console.log(this.items)
      console.log(this.$route)
    } catch (error) {
      console.log(error)
      // throw new Error('fjlskfjs')
    } finally {
      this.is_loading = false
    }
  },
  destroyed() {
    this.$store.commit('marketing_card_setting', null)
  },
  methods: {
    async getQuota() {
      let quantity = 0
      let limit = 0
      try {
        let tmp_start_at = this.$utils
          .getYYYYMMDDHHMMSS(this.$utils.calculateDate(-30).toISOString(), '-')
          .split(' ')[0]
        let tmp_end_at = this.$utils.getYYYYMMDDHHMMSS(this.$utils.calculateDate(30).toISOString(), '-').split(' ')[0]
        let result = await apiGetSubscriptionInfoWithData(this.$route.params.org_id, tmp_start_at, tmp_end_at)
        console.log('用量: ', result)
        let function_usage = result.usage.filter(function (function_usage) {
          return function_usage.function === 'SalesCardHistoryRemaining'
        })
        if (function_usage[0]) {
          quantity = function_usage[0].usage
        }

        let limit_usage = result.quotaVo.filter(function (quota) {
          return quota.function === 'SalesCardHistoryRemaining'
        })

        if (limit_usage[0]) {
          limit = limit_usage[0].limit
          if (limit_usage[0].addon) {
            limit += limit_usage[0].addon
          }
        }

        this.quota_setting.quantity = quantity
        this.quota_setting.limit = limit
        this.quota_setting.is_show = true
      } catch (error) {
        this.$root.vtoast.show({
          message: `取得用量失敗，原因:${error}`,
        })
      }
      return { quantity, limit }
    },
    initChart() {
      console.log(this.items)

      if (!this.items.length) {
        return
      }

      this.data.push({
        label: '圖卡任務管理',
        data: [],
        fill: true,
        borderColor: '#D1C4E9',
        tension: 0.5,
        backgroundColor: '#9575CD',
        spanGaps: true,
        borderWidth: 2,
        borderSkipped: false,
        borderRadius: 5,
        barPercentage: 0.5,
      })

      this.data[0]['data'] = this.items.map((item) => {
        return {
          x: [item['start_at'].split(' ')[0], item['end_at'].split(' ')[0]],
          y: item['setting_name'],
        }
      })

      console.log(this.data[0]['data'])

      // 取得所有資料裡面，最小的日期和最大的日期當作defalut值
      const chartData = [...this.data[0]['data']]

      let minDate = new Date(chartData[0].x[0])
      let maxDate = new Date(chartData[0].x[1])
      let startDate
      let endDate
      chartData.forEach((item) => {
        startDate = new Date(item.x[0])
        endDate = new Date(item.x[1])

        if (startDate < minDate) {
          minDate = startDate
        }

        if (endDate > maxDate) {
          maxDate = endDate
        }
      })
      this.chartStartAt = this.$utils.parseDateFormat(minDate).split(' ')[0]
      this.chartEndAt = this.$utils.parseDateFormat(maxDate).split(' ')[0]
    },
    initData: async function () {
      // 先抓網址上的頁碼，沒有預設就帶1
      let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
      let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.per_page
      let keyword = this.$route.query.keyword ? this.$route.query.keyword : ''
      let query_mode = this.$route.query.mode ? this.$route.query.mode : ''
      console.log('page_idx', page_idx)
      console.log('limit', limit)

      if (isNaN(limit)) {
        limit = 10
      }

      if (isNaN(page_idx)) {
        page_idx = 1
      }

      let match_mode_idx = this.tab_setting.modes.findIndex(function (mode) {
        return mode.id === query_mode
      })

      if (match_mode_idx !== -1) {
        this.tab_setting.tab = match_mode_idx
      } else {
        this.tab_setting.tab = 0
      }

      console.log('this.tab_setting.tab ', this.tab_setting.tab)

      try {
        let result = await apiCardFindBy(
          this.tab_setting.modes[this.tab_setting.tab].id,
          page_idx,
          limit,
          keyword,
          this.$route.params.container_id,
          this.$route.params.org_id
        )
        this.items = result.data.content
        this.page_setting = {
          is_show: true,
          selected_page: page_idx,
          total_page: result.data.totalPages,
          total_visible: 7,
        }

        this.selected_per_page = {
          name: `${limit}筆`,
          value: limit,
        }
        this.search = keyword
      } catch (error) {
        if (error.includes('401') || error.includes('403')) {
          this.$root.vtoast.show({
            message: `無權限使用此功能，原因:${error}`,
          })
          this.$router.push(`/${this.$route.params.org_id}/401`)
        } else {
          this.$root.vtoast.show({
            message: `取得圖卡失敗，原因: ${error}`,
          })
        }
      }
    },
    addNewSetting() {
      this.$router.push('edit')
      // this.$router.push('/:container_id/marketing_tool/marketing_card/edit');
    },
    getCard(setting_id) {
      let result = []
      result = apiGetCard(setting_id, this.$route.params.org_id)
        .then((resp) => {
          console.log(resp)
          const keys = ['start_at', 'campaign_start_at', 'end_at', 'campaign_end_at']
          keys.forEach((key) => {
            if (resp.data.data[key] !== null) {
              if (resp.data.data[key].includes('1970-01-01')) {
                resp.data.data[key] = ''
              }
            } else {
              resp.data.data[key] = ''
            }
          })

          this.$store.commit('old_setting_data', resp.data.data)
        })
        .catch((error) => {
          console.error(error)
          return []
        })

      return result
    },
    async viewInfo(item, mode) {
      console.log('viewInfo')
      console.log(item)
      if (mode !== 'on') {
        mode = 'off'
      }
      console.log('mode:', mode)
      // await this.getCard(item.id)
      // this.$router.push(`/ad/marketing_card/${item.container_id}/edit?setting_id=${item.id}&copy_mode=off`)
      // this.$store.commit('update_marketing_card', { setting_id : item.id })
      // let url = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_site/marketing_card/edit?setting_id=${item.id}`
      // window.location.href = url
      this.$router.push({
        path: `edit`,
        query: {
          setting_id: item.id,
          // copy_mode: mode
        },
      })
    },
    async copyCard(item) {
      try {
        let params = {
          id: item.id,
          org: this.$route.params.org_id,
        }
        let result = await apiCopyCard(params)
        let data = result.data
        console.log('copy_data:', data)
        console.log('result', result)
        let that = this
        this.$root.vtoast.show({
          color: 'primary',
          message: '複製成功',
        })
        setTimeout(function () {
          that.viewInfo(data, 'on')
        }, 1000)
      } catch (error) {
        console.log(error)
        let message = '複製圖卡失敗，原因: '
        if (error.includes('can only create')) {
          message += '圖卡數量達到上限，請加購或刪除現有圖卡。'
        } else {
          message += error
        }
        this.$root.vtoast.show({
          message: message,
        })
      }

      // this.viewInfo(item, true)
    },
    deleteSettingCard(item) {
      console.log('delete')
      console.log(item)
      let confirm_dialog = confirm(`請問您確定要刪除${item.setting_name}這份圖卡設定檔嗎？`)
      if (confirm_dialog) {
        apiDeleteCard(item.id, this.$route.params.org_id)
          .then(async (resp) => {
            console.log(resp)
            this.$root.vtoast.show({
              message: `刪除${item.setting_name}圖卡圖設定檔成功！`,
              color: 'primary',
            })
            await this.initData()
            await this.getQuota()
            // let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
            // let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.per_page
            // this.items = await this.getAllCardSettingList(page_idx, limit)
          })
          .catch((error) => {
            console.log(error)
            this.$root.vtoast.show({ message: '刪除圖卡失敗，原因: ' + error.response ? error.response : error })
          })
      } else {
        console.log('不刪除')
      }
    },
    async getAllCardSettingList(page_idx, limit) {
      let result
      result = await apiCardFindBy(page_idx, limit, this.$route.params.container_id, this.$route.params.org_id)
        .then((resp) => {
          console.log(resp)
          this.allCardSettingResponse = resp['data']['data']
          return resp['data']['data']['content']
        })
        .catch((error) => {
          console.log('list_error', error)
          if (error.includes('401') || error.includes('403')) {
            this.$root.vtoast.show({
              message: `無權限取得行銷圖卡，原因:${error}`,
            })
            this.$router.push(`/${this.$route.params.org_id}/401`)
          }
          console.log(error)
          return []
        })
      console.log(result)
      return result
    },
    previewCard(item) {
      console.log('item', item)
      this.preview_dialog.copy_setting = JSON.parse(JSON.stringify(this.preview_dialog))

      this.preview_dialog.setting = item
      const setting = item
      let start_at_string = setting.start_at
      let end_at_string = setting.end_at
      let campaign_start_at_string = setting.campaign_start_at
      let campaign_end_at_string = setting.campaign_end_at

      if (!campaign_start_at_string || !campaign_end_at_string) {
        console.log('1')
        this.preview_dialog.copy_mode_items = this.preview_dialog.mode_items.map(function (item) {
          if (item.value !== 'activity_card_setting') {
            item.disabled = true
          }
          return item
        })
      } else if (start_at_string === campaign_start_at_string && end_at_string === campaign_end_at_string) {
        console.log('2')
        this.preview_dialog.copy_mode_items = this.preview_dialog.mode_items.filter(function (item) {
          if (item.value !== 'activity_card_setting') {
            item.disabled = true
          }
          return item
        })
      } else {
        console.log('3')
        this.preview_dialog.copy_mode_items = this.preview_dialog.mode_items
      }

      this.preview_dialog.is_show = true

      // let message = ''
      // if (item.item.tags !== '') {
      //     message += '預覽網址: ' + item.item.preview_url + '?marketing-card=' + item.item.coupon_id + '&tags=' + item.item.tags + '&preview-card=' + item.mode;
      // }
      // else {
      //     message += '預覽網址: ' + item.item.preview_url + '?marketing-card=' + item.item.coupon_id + '&preview-card=' + item.mode
      // }
      // let preview_confirm = confirm(message.toString());
      // if (preview_confirm) {
      //     if (item.item.tags !== '') {
      //         window.open(item.item.preview_url + '?marketing-card=' + item.item.coupon_id + '&tags=' + item.item.tags + '&preview-card=' + item.mode, '_blank')
      //     } else {
      //         window.open(item.item.preview_url + '?marketing-card=' + item.item.coupon_id + '&preview-card=' + item.mode, '_blank')
      //     }
      // }
    },
    async updateItemsAfterBatchEdit() {
      try {
        // let page_idx = parseInt(this.$route.query.page) ? parseInt(this.$route.query.page) : 1
        // let limit = parseInt(this.$route.query.limit) ? parseInt(this.$route.query.limit) : this.per_page
        // this.items = await this.getAllCardSettingList(page_idx, limit)
        await this.initData()
        console.log(this.items)
        await this.$store.commit('marketing_card_setting', this.items)
        console.log(this.items)
        this.$refs.batchEditButton.$el.click()
        this.$root.vtoast.show({
          message: `批量更新圖卡設定檔成功！`,
          color: 'primary',
        })
      } catch (error) {
        this.$root.vtoast.show({ message: error.name + ': ' + error.message, color: 'error' })
      } finally {
        console.log('doned')
      }
    },
    generateLabels() {
      let currentDate = new Date()
      let date
      for (let i = 0; i < 30; i++) {
        date = new Date(currentDate.getTime() - i * 24 * 60 * 60 * 1000)
        console.log(date.getDate())
        this.chartDatas['datasets'][0]['data'].push(date.getDate())
      }
      this.chartDatas['datasets'][0]['data'].reverse()
    },
    generateDatas() {
      let random
      for (let i = 0; i < 30; i++) {
        random = Math.floor(Math.random() * 50) + 1

        this.chartDatas['labels'].push(Number(random))
      }
      // for (let i = 0; i < 30; i++) {
      //     this.chartDatas['datasets'][1]['data'].push(Number(100))
      // }
      console.log(this.chartDatas['datasets'][0]['data'])
    },
    chagePerPage: async function (selected_per_page) {
      let query = this.$route.query
      let tmp_query = { ...query, limit: selected_per_page.value, page: 1 }
      console.log(tmp_query)
      this.is_loading = true
      try {
        console.log(tmp_query)
        await this.$router.replace({ path: this.$route.path, query: tmp_query })
        await this.initData()
      } catch (err) {
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
      this.is_loading = false
    },
    closePreview() {
      this.preview_dialog = JSON.parse(JSON.stringify(this.preview_dialog.copy_setting))
    },
    async confirmPreview() {
      console.log('dialog', this.preview_dialog)
      console.log('dialog_setting', this.preview_dialog.setting)
      let id = this.preview_dialog.setting.id
      let org_id = this.$route.params.org_id
      let result = null
      try {
        result = await apiGetPreviewToken(id, org_id)
        console.log(result)
      } catch (error) {
        this.$root.vtoast.show({
          message: '取得預覽token失敗，原因:' + (error.response ? JSON.stringify(error.response) : error),
        })
      }

      if (!result) {
        return
      }

      try {
        let url = new URL(this.preview_dialog.setting.preview_url)
        console.log(url)

        if (this.preview_dialog.row === 'by_now') {
          url.searchParams.append('marketing-card', this.preview_dialog.setting.coupon_id)
        } else {
          url.searchParams.append('opt99_preview_token', result.token)
          url.searchParams.append('opt99_marketing_card_id', id)

          if (this.preview_dialog.row === 'by_activity') {
            let time_str = ''
            console.log('this.preview_dialog.selected_mode', this.preview_dialog.selected_mode.value)
            if (this.preview_dialog.selected_mode.value === 'warm_up_setting') {
              console.log('1')
              time_str = this.preview_dialog.setting.start_at
            } else if (this.preview_dialog.selected_mode.value === 'activity_card_setting') {
              console.log('2')
              time_str = this.preview_dialog.setting.campaign_start_at
              if (!time_str) {
                time_str = this.preview_dialog.setting.start_at
              }
            } else {
              console.log('3')
              time_str = this.preview_dialog.setting.campaign_end_at
              if (!time_str) {
                time_str = this.preview_dialog.setting.end_at
              }
            }
            time_str = time_str.replace(/-/g, '/')
            let time = new Date(time_str).toISOString()
            console.log('time', time_str)
            url.searchParams.append('opt99_target_time', time)
          } else {
            let time = new Date(this.preview_dialog.selected_time).toISOString()
            url.searchParams.append('opt99_target_time', time)
          }
        }

        window.open(url.href, '_blank')
      } catch (error) {
        this.$root.vtoast.show({
          message: '生成預覽連結失敗，原因:' + error,
        })
      }
    },
    foramtDisplayDate(date_string) {
      let date = date_string.split(' ')[0]
      let time = date_string.split(' ')[1]
      let html = `
                <div>${date}</div>
                <div>${time}</div>
            `
      return html
    },
    async changePageCallback(page) {
      this.is_loading = true
      console.log('changePage', page)
      this.page_setting.selected_page = page
      await this.initData()
      this.is_loading = false
    },
    rowPreview(item) {
      let url = new URL(item.preview_url)
      url.searchParams.append('opt99-marketing-card', item.coupon_id)
      this.$utils.openURL(url.href)
    },
    async searchKeyword(keyword) {
      console.log('keyword:', keyword)
      let query = this.$route.query
      let tmp_query = { ...query, limit: this.selected_per_page.value, page: 1, keyword: keyword }
      console.log(tmp_query)
      this.is_loading = true
      try {
        await this.$router.replace({ path: this.$route.path, query: tmp_query })
        await this.initData()
      } catch (err) {
        console.log('ex')
        console.log('err.name', err.name)
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
      this.is_loading = false
    },
    async changeTab(item) {
      console.log('item', item)
      let query = this.$route.query
      let tmp_query = { ...query, limit: this.selected_per_page.value, page: 1, keyword: '', mode: item.id }
      console.log(tmp_query)
      this.is_loading = true
      try {
        await this.$router.replace({ path: this.$route.path, query: tmp_query })
        await this.initData()
      } catch (err) {
        console.log('ex')
        console.log('err.name', err.name)
        if (err.name !== 'NavigationDuplicated') {
          throw err
        }
      }
      this.is_loading = false
    },
    formatTag(tag) {
      let new_tag = ''
      if (tag) {
        let tags = tag.split(',').reverse()
        new_tag = tags.join(',<br>')
      }
      return new_tag
    },
  },
}
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.mx-width-150 {
  max-width: 150px;
}
.mx-width-200 {
  max-width: 200px;
}
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
